module.exports = __webpack_public_path__ + "media/images/advert-img-04-da1dd88155230c2e328bd49a01e1ffff.png";